import { FC, ReactNode } from 'react'
import { PureQueryOptions } from '@apollo/client'
import styled from 'styled-components'
import {
  CoverLetterListItem_CurrentUserFragment,
  CoverLetterListItem_CoverLetterFragment,
} from 'generated/graphql'
import Button from '@app.components/Button'
import Loading from '@app.components/Loading/Loading'
import { LinkProps } from 'components/Link'
import BookMark from 'svgIcons/BookMark'
import CoverLetterScrap from '../../../CoverLetterScrap'
import CoverLetterListItemMo from './CoverLetterListItemMo'

interface CoverLetterListItemProps {
  currentUser?: CoverLetterListItem_CurrentUserFragment | null
  coverLetter?: CoverLetterListItem_CoverLetterFragment | null
  scrapIcon?: ReactNode
  showScrapCount?: boolean
  scrapRefetchQueries?: PureQueryOptions[]
  coverLetterHighlight?: string[] | null
  LinkProps?: LinkProps
}

const CoverLetterListItemMobile: FC<CoverLetterListItemProps> = ({
  coverLetter,
  currentUser,
  scrapIcon: initScrapIcon,
  showScrapCount = true,
  scrapRefetchQueries,
  coverLetterHighlight,
  LinkProps = {
    href: '/',
    naked: true,
  },
}) => {
  const scrapIcon = initScrapIcon ?? (
    <BookMark
      isOn={!!coverLetter?.isScrapped}
      strokeType="#666666"
      className="is-scrapped"
    />
  )

  return (
    <StyledWrapper>
      <CoverLetterListItemMo
        coverLetter={coverLetter}
        LinkProps={LinkProps}
        coverLetterHighlight={coverLetterHighlight}
      />

      {/* 스크랩 버튼 */}
      <div className="scrap">
        <CoverLetterScrap
          coverLetter={coverLetter}
          currentUser={currentUser}
          refetchQueries={scrapRefetchQueries}
        >
          {({ scrapCoverLetter, loading, scrapCount }) => (
            <>
              {!loading ? (
                <Button
                  onClick={scrapCoverLetter}
                  className="scrap-button"
                  disabled={loading}
                >
                  {scrapIcon}
                </Button>
              ) : (
                <i className="loading-icon">
                  <Loading />
                </i>
              )}
              {showScrapCount && (
                <p
                  className={`content ${
                    coverLetter?.isScrapped && 'is-scrapped'
                  }`}
                >
                  {(scrapCount || 0) >= 1000 ? '999+' : scrapCount}
                </p>
              )}
            </>
          )}
        </CoverLetterScrap>
      </div>
    </StyledWrapper>
  )
}

export default CoverLetterListItemMobile

const StyledWrapper = styled.div`
  padding: 20px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .content {
    font-size: 16px;
    color: #999999;
    font-weight: normal;
    text-align: center;
  }

  .scrap {
    text-align: center;
    width: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 20px;
    margin-right: 0;
  }

  .is-scrapped {
    color: ${({ theme }) => theme.color.primary_2} !important;
    font-weight: 500;
  }

  .scrap-button {
    background: none;
    padding: 12px 12px 5px 12px;
    color: #e8e8e8;

    &:hover {
      color: ${({ theme }) => theme.color.primary_2};
    }

    > svg {
      width: 12px;
    }
  }

  .loading-icon {
    height: 33px;
    width: max-content;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .link {
    &:hover {
      text-decoration: underline;
    }
  }
`
